<template>
  <div class="dropdown-wrapper">
    <v-select
      v-bind="attrs"
      variant="outlined"
      :items="items"
      :label="label"
      :placeholder="label"
      :rules="rules"
      :item-title="itemTitle"
      :item-value="itemValue"
      :model-value="modelValue"
      :return-object="returnObject"
      :disabled="disabled"
      :menu-props="{ attach: '#approot' }"
      @update:modelValue="emit('update:modelValue', $event)"
    >
      <slot />
    </v-select>
  </div>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue';

defineOptions({
  name: "Dropdown",
  inheritAttrs: false
});

defineProps<{
  modelValue: any;
  items: any[];
  label?: string;
  rules?: any[];
  itemTitle?: string | object | ((item: any) => string);
  itemValue?: string;
  returnObject?: boolean;
  disabled?: boolean;
}>();

const emit = defineEmits(['update:modelValue']);

const attrs = useAttrs();
</script>

<style lang="scss">
.dropdown-wrapper {
  & > .v-text-field--outlined > .v-input__control > .v-field__input {
    background-color: rgb(var(--v-theme-secondary));
  }
  & > .v-text-field--outlined.v-input--is-focused > .v-input__control > .v-field__input,
  & > .v-text-field--outlined.v-input--is-dirty > .v-input__control > .v-field__input {
    background-color: rgb(var(--v-theme-white));
  }

  .v-select.v-text-field--outlined:not(.v-text-field--single-line) .v-select__selections {
    padding-top: .25rem;
    padding-bottom: .25rem;
  }
}

.v-menu__content--fixed {
  @-moz-document url-prefix() {
    position: absolute;
  }
}

.v-overlay__content.v-select__content {
  border-radius: 2px !important;
  box-shadow:
    rgba(0, 0, 0, 0.2) 0px 5px 5px -3px,
    rgba(0, 0, 0, 0.14) 0px 8px 10px 1px,
    rgba(0, 0, 0, 0.12) 0px 3px 14px 2px !important;
  font-family: 'barlow-semi-condensed-1', HelveticaNeue, Helvetica Neue, Helvetica-Neue, Helvetica, Arial, sans-serif !important;
  font-size: 18px !important;
  line-height: 27px !important;
  max-height: 304px !important;
  min-width: 400px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  box-sizing: border-box !important;
  background-color: white !important;
  display: block !important;
  z-index: 2000 !important;
  padding: 0 !important;
  margin: 0 !important;
}
</style>
